import React from 'react';
import ToastMessage from '../../components/shared/Toasts';

const failPreClearedSubmission = (
    <ToastMessage icon="exclamation">
        <div id="preference-error">
            Something Appears to be Wrong. <br />
            Contact us through the mail icon on the bottom of the screen for assistance
        </div>
    </ToastMessage>
);

export default {
    failPreClearedSubmission
};
